// Tour translations live in Firestore, on each tour document:
//
//   tours/<id>.translations = {
//     pt: { title, description, whatsIncluded, highlights, stops,
//           whatToExpect, additionalInfo, notSuitableFor, accessibility,
//           cancellationPolicy, scheduleInfo: { frequency } },
//     es: { ... }, de: { ... }, fr: { ... },
//   }
//
// Same shapes as the English fields (lists in the same order). Anything
// missing or empty shows in English. Edited in the admin tour editor
// (Translations step).

import { DEFAULT_LOCALE, mergeDeep } from "./index";

// Text fields that can be translated. Everything else (prices, images,
// times, coordinates...) always comes from the English tour.
export const TOUR_TEXT_FIELDS = [
  "title",
  "description",
  "whatsIncluded",
  "highlights",
  "stops",
  "whatToExpect",
  "additionalInfo",
  "notSuitableFor",
  "accessibility",
  "cancellationPolicy",
  "scheduleInfo",
];

// Empty strings in a translation mean "not translated yet": keep English
function dropEmpty(value) {
  if (Array.isArray(value)) return value.map(dropEmpty);
  if (value && typeof value === "object") {
    const out = {};
    Object.keys(value).forEach((key) => {
      const v = dropEmpty(value[key]);
      if (v !== undefined) out[key] = v;
    });
    return out;
  }
  if (typeof value === "string" && !value.trim()) return undefined;
  return value;
}

// The tour in `locale`, with English for anything not translated
export function localizeTour(tour, locale) {
  if (!tour || !locale || locale === DEFAULT_LOCALE) return tour;
  const translation = tour.translations && tour.translations[locale];
  if (!translation) return tour;

  const picked = {};
  TOUR_TEXT_FIELDS.forEach((field) => {
    if (translation[field] !== undefined) picked[field] = dropEmpty(translation[field]);
  });
  return mergeDeep(tour, picked);
}

export function hasTranslation(tour, locale) {
  return !!(tour && tour.translations && tour.translations[locale] && tour.translations[locale].title);
}
